import { render, staticRenderFns } from "./FenceMaterials.vue?vue&type=template&id=454aaa01"
import script from "./FenceMaterials.vue?vue&type=script&lang=js"
export * from "./FenceMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports